export const generatedPromotionClosureLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-20T00:00:00.000Z",
  "mode": "deterministic-promotion-closure-ledger",
  "operatingRule": "Blocked science, resource, economics, and materials gates must have executable closure plans before any customer-facing package can be called business-grade.",
  "planCount": 5,
  "blockedClosurePlanCount": 3,
  "partialClosurePlanCount": 2,
  "readyForCustomerClaimCount": 0,
  "promotionAllowed": false,
  "evidenceHashes": {
    "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
    "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
  },
  "closureSequence": [
    {
      "releaseGateId": "model-validation-protocols",
      "priority": "P0",
      "closureState": "partial-proof",
      "firstAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
      "closurePlanHash": "sha256-27f115140d4bf62905eb92596dbc461965e088c482a6a4ad3c9ba54f5c59e4b7"
    },
    {
      "releaseGateId": "runtime-sidecar-promotion",
      "priority": "P0",
      "closureState": "partial-proof",
      "firstAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
      "closurePlanHash": "sha256-15c4d9dbd729790bcfde9a09ebaa1b54c55ad99ea4d2e153d68081c5e27d8018"
    },
    {
      "releaseGateId": "economics-promotion",
      "priority": "P1",
      "closureState": "blocked-proof",
      "firstAction": "Capture a reviewed commercial-launch-pricing payload with raw and normalized hashes before this source can promote model outputs.",
      "closurePlanHash": "sha256-dbdad43970e91dbeb9e1a15f9521568c48a72bdd6038f84fd96e71decf26c4d9"
    },
    {
      "releaseGateId": "materials-process-promotion",
      "priority": "P1",
      "closureState": "blocked-proof",
      "firstAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
      "closurePlanHash": "sha256-410c338497ac236c233d703b329b085d0d425c7796bb0b54bf3c474b9a5e0e4d"
    },
    {
      "releaseGateId": "resource-candidate-promotion",
      "priority": "P1",
      "closureState": "blocked-proof",
      "firstAction": "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
      "closurePlanHash": "sha256-053cb17ecdd9afcd3bfd272754de376014200ab0370e5dae978f31be1bf8b864"
    }
  ],
  "closurePlans": [
    {
      "releaseGateId": "model-validation-protocols",
      "title": "Model validation protocol closure",
      "owner": "Science/product governance",
      "priority": "P0",
      "closureState": "partial-proof",
      "customerImpact": "Turns decision-support heuristics into reviewable model domains with acceptance criteria.",
      "readyForCustomerClaim": false,
      "promotionBoundary": "This closure plan is governance and operations evidence only. It does not validate the underlying science or commercial claim.",
      "requiredProofPackages": {
        "sourcePayloadWorkOrders": [
          {
            "id": "source-ingest-spice-gf",
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-067366bfd5d48f4d3ec03a31d3ff19007a6aa77d692b3741d5949721a6fb75b8"
          },
          {
            "id": "source-ingest-horizons-api",
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed ephemeris-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10"
          },
          {
            "id": "source-ingest-horizons-mercury-2024",
            "sourceId": "horizons-mercury-2024",
            "title": "JPL Horizons Mercury Physical Data",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed body-physical-data payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-e7d428df65ab7cdaf3a65ff87baef2566e262a1959f270ef265ea8d5963853d8"
          },
          {
            "id": "source-ingest-nist-codata",
            "sourceId": "nist-codata",
            "title": "2022 CODATA Fundamental Physical Constants",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d"
          },
          {
            "id": "source-ingest-sbdb-api",
            "sourceId": "sbdb-api",
            "title": "JPL Small-Body Database API",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-03df633e2ee73cac09d65f2a2f5428e468e6ac89008e3f4378d6c8fd575ca8a5"
          },
          {
            "id": "source-ingest-cad-api",
            "sourceId": "cad-api",
            "title": "SBDB Close Approach Data API",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed close-approach-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71"
          },
          {
            "id": "source-ingest-orekit",
            "sourceId": "orekit",
            "title": "Orekit",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astrodynamics-library payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-32e680e406eeddf3facdf231b3f530178321968183591cbb59f8a4f88d12eec3"
          },
          {
            "id": "source-ingest-gmat",
            "sourceId": "gmat",
            "title": "General Mission Analysis Tool",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed mission-analysis-tool payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d"
          },
          {
            "id": "source-ingest-openmdao",
            "sourceId": "openmdao",
            "title": "OpenMDAO",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed optimization-framework payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-c6f5e90eb17541785cd427c2bbd3aa01691aca58bd56e984e39f91c732f1a20b"
          },
          {
            "id": "source-ingest-dymos",
            "sourceId": "dymos",
            "title": "Dymos",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed optimal-control-library payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0"
          },
          {
            "id": "source-ingest-tudat",
            "sourceId": "tudat",
            "title": "Tudat Space / TudatPy",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astrodynamics-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-036f1a6704d95b5f93ff6bca5ea75a05e823e85cb50ec2048eda3a5267a33a1a"
          },
          {
            "id": "source-ingest-iau-sofa",
            "sourceId": "iau-sofa",
            "title": "Standards of Fundamental Astronomy",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astronomy-standards payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-4e64bcced35d7a9497724400b98fb6e2a86515ae74b1c7048f63bbad8b99f06e"
          },
          {
            "id": "source-ingest-pds",
            "sourceId": "pds",
            "title": "Planetary Data System",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed mission-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11"
          },
          {
            "id": "source-ingest-mpc",
            "sourceId": "mpc",
            "title": "Minor Planet Center Data",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed small-body-observation-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-6f4ec4d25fd364055d8c199c2c900fb140fcfd4c471ff4343dd8cb45ab928bc7"
          },
          {
            "id": "source-ingest-esa-psa",
            "sourceId": "esa-psa",
            "title": "ESA Planetary Science Archive",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed planetary-mission-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615"
          },
          {
            "id": "source-ingest-jaxa-darts",
            "sourceId": "jaxa-darts",
            "title": "DARTS Space Science Data Archive",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed space-science-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2"
          },
          {
            "id": "source-ingest-nasa-mercury",
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed official-factsheet payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5b53cd471db10365d2e0a9126eb6fd841ddbed0292a6202d9865d5c32e634bb3"
          }
        ],
        "queryCustodyRecords": [
          {
            "queryId": "query-horizons-mercury-object-record",
            "sourceId": "horizons-api",
            "provider": "NASA/JPL Horizons",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-f466d56ecbd487c3c193fe148d3cfb15b4e7ec1383bef83bfcada6394b50e3ed"
          },
          {
            "queryId": "query-horizons-earth-mercury-geometry",
            "sourceId": "horizons-api",
            "provider": "NASA/JPL Horizons",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-3c6b3a6f0e557e81bee39f57058f69eed09820a1250866c0b70e31bcdeae3bf5"
          },
          {
            "queryId": "query-sbdb-asteroid-record-screen",
            "sourceId": "sbdb-api",
            "provider": "NASA/JPL Small-Body Database",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-06222352a14f2aa3df3d8007b9c4538c7d38c0d5740f734b9b7e091f9ff0d5ab"
          },
          {
            "queryId": "query-cad-2026-close-approach-screen",
            "sourceId": "cad-api",
            "provider": "NASA/JPL CNEOS CAD",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-e1dd6bf53bf1f8deedd1eca765ca58f8d04ae1cc2dcbd2fc7cc60efe3af8258d"
          },
          {
            "queryId": "query-gmat-registry-custody",
            "sourceId": "gmat",
            "provider": "NASA",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-8c0470aba1f0efa5938d8513c4117028fd4bebaf74592944f643ddfe29c65f50"
          },
          {
            "queryId": "query-orekit-registry-custody",
            "sourceId": "orekit",
            "provider": "CS Group / open source community",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-640b0ea9a67ab695a4474da2597d851641ddc776f1e3108d188e946499c7a39c"
          },
          {
            "queryId": "query-spice-gf-registry-custody",
            "sourceId": "spice-gf",
            "provider": "NASA NAIF",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-d900ecd0a5bb8d01922e2c03b7ccd375d9a58f089b6785b42166e7c86eb061c0"
          },
          {
            "queryId": "query-tudat-registry-custody",
            "sourceId": "tudat",
            "provider": "TU Delft Astrodynamics Toolbox community",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-03a7901d761ce7a8a15f9d182b1c10a407d1de55dd8cf5c5592ae8bdeaacf4db"
          }
        ],
        "runtimeContracts": [
          {
            "contractId": "spice-gf-event-window-v1",
            "tool": "NASA NAIF SPICE Geometry Finder",
            "readinessState": "runtime-artifact-promoted",
            "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
            "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
            "readinessHash": "sha256-a30df59ba18a6787ab37d68842db0d846b284c3c00af038b144fe3a2027ff6d3"
          },
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
            "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
            "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
            "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
            "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
            "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
            "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558"
          }
        ],
        "requiredRuntimeArtifacts": [
          "SPICE event-window artifact tied to source snapshots.",
          "Trajectory propagation and transfer artifacts from at least two independent tools.",
          "Validation protocol rows with pass/fail criteria, tolerance, source refs, and residuals."
        ],
        "linkedEvidenceGaps": [
          {
            "id": "gap-runtime-orekit-propagation-v1",
            "category": "runtime-sidecar",
            "title": "Orekit runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 78,
            "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
          },
          {
            "id": "gap-runtime-gmat-transfer-v1",
            "category": "runtime-sidecar",
            "title": "NASA GMAT runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 77,
            "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
          },
          {
            "id": "gap-runtime-tudat-transfer-v1",
            "category": "runtime-sidecar",
            "title": "Tudat runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 77,
            "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
          },
          {
            "id": "gap-candidate-source-2026-em",
            "category": "candidate-source-custody",
            "title": "2026 EM candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
            "gapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531"
          },
          {
            "id": "gap-candidate-source-2026-jm2",
            "category": "candidate-source-custody",
            "title": "2026 JM2 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
            "gapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d"
          },
          {
            "id": "gap-candidate-source-2026-dn5",
            "category": "candidate-source-custody",
            "title": "2026 DN5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
            "gapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433"
          },
          {
            "id": "gap-resource-taxonomy-spectra-record",
            "category": "resource-evidence",
            "title": "Taxonomy or spectra record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff"
          },
          {
            "id": "gap-resource-cad-close-approach-record",
            "category": "resource-evidence",
            "title": "CAD close-approach record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach CAD close-approach record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-8fc55bc0f1f95de19673711ea406c890ceec3b66c4defee971ec3228592c2c74"
          },
          {
            "id": "gap-resource-mission-or-archive-product",
            "category": "resource-evidence",
            "title": "Mission/archive product",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach Mission/archive product records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-8c7f9a7e86309ac82dcb0320ab62b11555bc49b14ab3f3fefa9b10e000261036"
          },
          {
            "id": "gap-resource-mpc-observation-bridge",
            "category": "resource-evidence",
            "title": "MPC observation bridge",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach MPC observation bridge records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-1f578fbb47b5ebc0f44778b06ed6b6c850ea36eec18607c6077aedc809b65309"
          },
          {
            "id": "gap-resource-sbdb-orbit-record",
            "category": "resource-evidence",
            "title": "SBDB orbit and physical-property record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach SBDB orbit and physical-property record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-cf5576baa620019c4c2d21bb4bcc8b4de7cecb89d16b7fb723565209fa14f084"
          },
          {
            "id": "gap-trace-hybrid",
            "category": "scenario-trace-review",
            "title": "Hybrid Moon -> Asteroid -> Mercury trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-9b2025b5a713e047c204f589e827d16999d379dfd70d83f2afe5ce703be751cd"
          },
          {
            "id": "gap-trace-moon-first",
            "category": "scenario-trace-review",
            "title": "Moon-first Bootstrap trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a07797a7875d70590b15bfb0660c0d5391f295e6949d908cda489948b8388ce6"
          },
          {
            "id": "gap-candidate-source-2026-et3",
            "category": "candidate-source-custody",
            "title": "2026 ET3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-et3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-et3-source-intake-report.json.",
            "gapHash": "sha256-74f4bc84e7ea823c265ec80211167548ff6ed72bc97064d79d0d439737dba7f9"
          },
          {
            "id": "gap-candidate-source-2026-fs5",
            "category": "candidate-source-custody",
            "title": "2026 FS5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-fs5-source-intake-report.json.",
            "gapHash": "sha256-827bd3aee44db5fc618a31ce27ffe6ecd3fb358744fb0d70a7048d965fc0bc7c"
          },
          {
            "id": "gap-candidate-source-2026-hz4",
            "category": "candidate-source-custody",
            "title": "2026 HZ4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-hz4-source-intake-report.json.",
            "gapHash": "sha256-9d9dd560b7581f37ddf737dc9e7ac461bffbd398fe1b11473fe309590b73d227"
          },
          {
            "id": "gap-candidate-source-2026-jn4",
            "category": "candidate-source-custody",
            "title": "2026 JN4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jn4-source-intake-report.json.",
            "gapHash": "sha256-dc8d4a2f5c93e9e5ef37344887b384fddeaa72bf40230d4ad4fd43476a5899c8"
          },
          {
            "id": "gap-candidate-source-2026-jv3",
            "category": "candidate-source-custody",
            "title": "2026 JV3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jv3-source-intake-report.json.",
            "gapHash": "sha256-f8c55ed733b65b3672fb79d86c0847d1ccf231bd775aece43f126a3f48945771"
          },
          {
            "id": "gap-candidate-source-2026-ku1",
            "category": "candidate-source-custody",
            "title": "2026 KU1 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-ku1-source-intake-report.json.",
            "gapHash": "sha256-b38dd56c77c9f8a9c1c8b893a203ffd3193592a54c6590781414b56ccb73cf99"
          },
          {
            "id": "gap-candidate-source-2026-lx",
            "category": "candidate-source-custody",
            "title": "2026 LX candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-lx-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-lx-source-intake-report.json.",
            "gapHash": "sha256-00800b5fd8d8d2357ce6bb2e7406e8443edea5941cf0925c7fc8e3044c27aa74"
          },
          {
            "id": "gap-trace-asteroid-first",
            "category": "scenario-trace-review",
            "title": "Asteroid Feedstock-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-1507bb3a073d36e0376fcdee4f57ae7676eff4e7ece630c25f0ec35df9c8e31e"
          },
          {
            "id": "gap-trace-mars-first",
            "category": "scenario-trace-review",
            "title": "Mars-first Conventional Expansion trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a001e470feaccc1ac563477c2a78c86baa6c578879e643c6f63c914083e159a0"
          },
          {
            "id": "gap-trace-mercury-orbit",
            "category": "scenario-trace-review",
            "title": "Mercury Orbit-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a5fa55a583c4dbdad7357b606c59584859528aed662014720d5d7ff86c552ab9"
          },
          {
            "id": "gap-trace-mercury-polar",
            "category": "scenario-trace-review",
            "title": "Mercury Polar Surface-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-99163eaa428fa45c275a16aa56da8c959ddcde28d52917805ba9a1155aaa8262"
          }
        ],
        "candidateSourceWorkOrders": []
      },
      "unresolvedCounts": {
        "sourceWorkOrders": 17,
        "candidateSourceWorkOrders": 0,
        "runtimeContracts": 3,
        "evidenceGaps": 24
      },
      "promotionSubstates": {
        "sourceCustody": null,
        "resourcePromotion": null,
        "customerUse": null
      },
      "proofBurden": [
        "Every protocol names its required source and runtime gates.",
        "Commercial-use state remains blocked unless all protocol blockers are resolved.",
        "Validation references point to hash-backed artifacts, not prose-only claims.",
        "Attach reviewed payload or runtime-artifact intake reports before changing this closure state.",
        "Keep planner heuristics labeled as heuristics until promotion gates pass."
      ],
      "executableCommands": [
        "npm run science:validation",
        "npm run science:sidecar:promotion",
        "npm run science:release"
      ],
      "nextSprintActions": [
        "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
        "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
        "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      ],
      "closurePlanHash": "sha256-27f115140d4bf62905eb92596dbc461965e088c482a6a4ad3c9ba54f5c59e4b7"
    },
    {
      "releaseGateId": "runtime-sidecar-promotion",
      "title": "Runtime sidecar promotion closure",
      "owner": "Science compute",
      "priority": "P0",
      "closureState": "partial-proof",
      "customerImpact": "Raises mission-design credibility by replacing scaffold evidence with reproducible runtime artifacts.",
      "readyForCustomerClaim": false,
      "promotionBoundary": "This closure plan is governance and operations evidence only. It does not validate the underlying science or commercial claim.",
      "requiredProofPackages": {
        "sourcePayloadWorkOrders": [
          {
            "id": "source-ingest-spice-gf",
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-067366bfd5d48f4d3ec03a31d3ff19007a6aa77d692b3741d5949721a6fb75b8"
          },
          {
            "id": "source-ingest-horizons-api",
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed ephemeris-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10"
          },
          {
            "id": "source-ingest-horizons-mercury-2024",
            "sourceId": "horizons-mercury-2024",
            "title": "JPL Horizons Mercury Physical Data",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed body-physical-data payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-e7d428df65ab7cdaf3a65ff87baef2566e262a1959f270ef265ea8d5963853d8"
          },
          {
            "id": "source-ingest-nist-codata",
            "sourceId": "nist-codata",
            "title": "2022 CODATA Fundamental Physical Constants",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d"
          },
          {
            "id": "source-ingest-orekit",
            "sourceId": "orekit",
            "title": "Orekit",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astrodynamics-library payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-32e680e406eeddf3facdf231b3f530178321968183591cbb59f8a4f88d12eec3"
          },
          {
            "id": "source-ingest-gmat",
            "sourceId": "gmat",
            "title": "General Mission Analysis Tool",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed mission-analysis-tool payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d"
          },
          {
            "id": "source-ingest-openmdao",
            "sourceId": "openmdao",
            "title": "OpenMDAO",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed optimization-framework payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-c6f5e90eb17541785cd427c2bbd3aa01691aca58bd56e984e39f91c732f1a20b"
          },
          {
            "id": "source-ingest-dymos",
            "sourceId": "dymos",
            "title": "Dymos",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed optimal-control-library payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0"
          },
          {
            "id": "source-ingest-tudat",
            "sourceId": "tudat",
            "title": "Tudat Space / TudatPy",
            "domain": "trajectory-and-optimization",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astrodynamics-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-036f1a6704d95b5f93ff6bca5ea75a05e823e85cb50ec2048eda3a5267a33a1a"
          },
          {
            "id": "source-ingest-iau-sofa",
            "sourceId": "iau-sofa",
            "title": "Standards of Fundamental Astronomy",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed astronomy-standards payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-4e64bcced35d7a9497724400b98fb6e2a86515ae74b1c7048f63bbad8b99f06e"
          },
          {
            "id": "source-ingest-jaxa-darts",
            "sourceId": "jaxa-darts",
            "title": "DARTS Space Science Data Archive",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed space-science-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2"
          },
          {
            "id": "source-ingest-nasa-mercury",
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed official-factsheet payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5b53cd471db10365d2e0a9126eb6fd841ddbed0292a6202d9865d5c32e634bb3"
          }
        ],
        "queryCustodyRecords": [
          {
            "queryId": "query-gmat-registry-custody",
            "sourceId": "gmat",
            "provider": "NASA",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-8c0470aba1f0efa5938d8513c4117028fd4bebaf74592944f643ddfe29c65f50"
          },
          {
            "queryId": "query-orekit-registry-custody",
            "sourceId": "orekit",
            "provider": "CS Group / open source community",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-640b0ea9a67ab695a4474da2597d851641ddc776f1e3108d188e946499c7a39c"
          },
          {
            "queryId": "query-spice-gf-registry-custody",
            "sourceId": "spice-gf",
            "provider": "NASA NAIF",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-d900ecd0a5bb8d01922e2c03b7ccd375d9a58f089b6785b42166e7c86eb061c0"
          },
          {
            "queryId": "query-tudat-registry-custody",
            "sourceId": "tudat",
            "provider": "TU Delft Astrodynamics Toolbox community",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-03a7901d761ce7a8a15f9d182b1c10a407d1de55dd8cf5c5592ae8bdeaacf4db"
          }
        ],
        "runtimeContracts": [
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
            "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
            "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
            "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
            "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
            "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
            "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558"
          }
        ],
        "requiredRuntimeArtifacts": [
          "Orekit propagation artifact with residual bounds.",
          "GMAT transfer script and output manifest with checksum.",
          "Tudat comparison artifact with disagreement bounds against Orekit/GMAT."
        ],
        "linkedEvidenceGaps": [
          {
            "id": "gap-runtime-orekit-propagation-v1",
            "category": "runtime-sidecar",
            "title": "Orekit runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 78,
            "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
          },
          {
            "id": "gap-runtime-gmat-transfer-v1",
            "category": "runtime-sidecar",
            "title": "NASA GMAT runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 77,
            "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
          },
          {
            "id": "gap-runtime-tudat-transfer-v1",
            "category": "runtime-sidecar",
            "title": "Tudat runtime artifact promotion",
            "priorityLane": "P0-critical-path",
            "priorityScore": 77,
            "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
          },
          {
            "id": "gap-trace-hybrid",
            "category": "scenario-trace-review",
            "title": "Hybrid Moon -> Asteroid -> Mercury trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-9b2025b5a713e047c204f589e827d16999d379dfd70d83f2afe5ce703be751cd"
          },
          {
            "id": "gap-trace-moon-first",
            "category": "scenario-trace-review",
            "title": "Moon-first Bootstrap trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a07797a7875d70590b15bfb0660c0d5391f295e6949d908cda489948b8388ce6"
          },
          {
            "id": "gap-trace-asteroid-first",
            "category": "scenario-trace-review",
            "title": "Asteroid Feedstock-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-1507bb3a073d36e0376fcdee4f57ae7676eff4e7ece630c25f0ec35df9c8e31e"
          },
          {
            "id": "gap-trace-mars-first",
            "category": "scenario-trace-review",
            "title": "Mars-first Conventional Expansion trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a001e470feaccc1ac563477c2a78c86baa6c578879e643c6f63c914083e159a0"
          },
          {
            "id": "gap-trace-mercury-orbit",
            "category": "scenario-trace-review",
            "title": "Mercury Orbit-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a5fa55a583c4dbdad7357b606c59584859528aed662014720d5d7ff86c552ab9"
          },
          {
            "id": "gap-trace-mercury-polar",
            "category": "scenario-trace-review",
            "title": "Mercury Polar Surface-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-99163eaa428fa45c275a16aa56da8c959ddcde28d52917805ba9a1155aaa8262"
          }
        ],
        "candidateSourceWorkOrders": []
      },
      "unresolvedCounts": {
        "sourceWorkOrders": 12,
        "candidateSourceWorkOrders": 0,
        "runtimeContracts": 3,
        "evidenceGaps": 9
      },
      "promotionSubstates": {
        "sourceCustody": null,
        "resourcePromotion": null,
        "customerUse": null
      },
      "proofBurden": [
        "Runtime artifact matches the sidecar contract schema.",
        "Inputs, command, tool version, environment, output hash, and reviewer decision are recorded.",
        "Independent comparison residuals are present before mission-design claims promote.",
        "Attach reviewed payload or runtime-artifact intake reports before changing this closure state.",
        "Keep planner heuristics labeled as heuristics until promotion gates pass."
      ],
      "executableCommands": [
        "npm run science:sidecar:runtime-preflight",
        "npm run science:sidecar:intake -- <runtime-artifact.json>",
        "npm run science:sidecar:promotion"
      ],
      "nextSprintActions": [
        "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
        "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
        "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      ],
      "closurePlanHash": "sha256-15c4d9dbd729790bcfde9a09ebaa1b54c55ad99ea4d2e153d68081c5e27d8018"
    },
    {
      "releaseGateId": "economics-promotion",
      "title": "Economics promotion closure",
      "owner": "Business modeling",
      "priority": "P1",
      "closureState": "blocked-proof",
      "customerImpact": "Supports paid feasibility packages with dated cost ranges, uncertainty, and source-backed model inputs.",
      "readyForCustomerClaim": false,
      "promotionBoundary": "This closure plan is governance and operations evidence only. It does not validate the underlying science or commercial claim.",
      "requiredProofPackages": {
        "sourcePayloadWorkOrders": [
          {
            "id": "source-ingest-spacex-rideshare",
            "sourceId": "spacex-rideshare",
            "title": "SpaceX Rideshare Program",
            "domain": "economics-and-business-evidence",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed commercial-launch-pricing payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5ce3bc9316083ce268f83af9f6cb2470d854f556faa2d1f528d2feddd975fb01"
          },
          {
            "id": "source-ingest-nasa-clps",
            "sourceId": "nasa-clps",
            "title": "Commercial Lunar Payload Services",
            "domain": "economics-and-business-evidence",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed commercial-lunar-delivery-program payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-103b2187a271bdebfe18b355f043669ad9fec03243cedf0839aebc8c289670b2"
          },
          {
            "id": "source-ingest-nasa-cost-estimating-handbook",
            "sourceId": "nasa-cost-estimating-handbook",
            "title": "NASA Cost Estimating Handbook",
            "domain": "economics-and-business-evidence",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed cost-estimating-methodology payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-f74bd3fc758ddea4d2670ac38bd556db89c2345ac4aa833a8f9e9b5388747030"
          },
          {
            "id": "source-ingest-usaspending",
            "sourceId": "usaspending",
            "title": "USAspending.gov",
            "domain": "economics-and-business-evidence",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed federal-award-database payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-118104b16dfcfdaa9710627d94ccf03c2720317e8420d1ab0299f99cba314823"
          },
          {
            "id": "source-ingest-sec-edgar",
            "sourceId": "sec-edgar",
            "title": "SEC EDGAR",
            "domain": "economics-and-business-evidence",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed public-company-filings payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-2fbe443ab4a09bc99bc5cf31b7633c0adf9375136831a5935e1574e13cceb994"
          }
        ],
        "queryCustodyRecords": [
          {
            "queryId": "query-nasa-clps-registry-custody",
            "sourceId": "nasa-clps",
            "provider": "NASA",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-be84a795718f8a966ee66cdfa9f5ad84849dddc6fc6668ff773da4442985fc8d"
          },
          {
            "queryId": "query-nasa-cost-estimating-handbook-registry-custody",
            "sourceId": "nasa-cost-estimating-handbook",
            "provider": "NASA",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-320b21170eecde0ed8c1198691bea72e58a49ffa58d6955f87c232a19915e1ae"
          },
          {
            "queryId": "query-sec-edgar-registry-custody",
            "sourceId": "sec-edgar",
            "provider": "U.S. Securities and Exchange Commission",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-e2af3b79fc591b99801741b7de2f60ff20059ad630a6216ec68f8eb6b34da569"
          },
          {
            "queryId": "query-spacex-rideshare-registry-custody",
            "sourceId": "spacex-rideshare",
            "provider": "SpaceX",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-ede2431508c4a80e9858cf188781742e91a9a7d46a853403d65947ca39a4884f"
          },
          {
            "queryId": "query-usaspending-registry-custody",
            "sourceId": "usaspending",
            "provider": "U.S. Treasury / federal agencies",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-cda0dd1c80bb59ddf30f6f202bf1af37a409d22eb358192c6f0e69c4e57d3b85"
          }
        ],
        "runtimeContracts": [
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "readinessState": "runtime-artifact-promoted",
            "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
            "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
            "readinessHash": "sha256-6c97cc882c1df4c7705d2dda567cd773d0dbf2397ade5edbb0514b9aaaebb1d5"
          }
        ],
        "requiredRuntimeArtifacts": [
          "OpenMDAO/Dymos or equivalent logistics optimization artifact with cost-sensitivity inputs.",
          "Monte Carlo economics frontier regenerated from normalized cost records."
        ],
        "linkedEvidenceGaps": [
          {
            "id": "gap-economics-launch-list-price-source",
            "category": "economics-normalization",
            "title": "Launch list-price source intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 71,
            "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
            "gapHash": "sha256-9ec3287429344e07a1ef221f40ac591b8ee993eed464f232f27c9cba41776d15"
          },
          {
            "id": "gap-economics-capex-estimating-method",
            "category": "economics-normalization",
            "title": "Capex estimating method",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Normalize capex records into model-ready numeric inputs with calibration artifacts.",
            "gapHash": "sha256-7413a56a815cc9cf360707209e566a759709a1676cf0d0aa9ddd8b7fda68a4df"
          },
          {
            "id": "gap-economics-lunar-delivery-contract-envelope",
            "category": "economics-normalization",
            "title": "Commercial lunar delivery contract envelope",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Normalize lunar-delivery-cost records into model-ready numeric inputs with calibration artifacts.",
            "gapHash": "sha256-02efe5d526fdd188a9e61dfc53ed80418e96900ada3a1317e46a523ca527ed40"
          },
          {
            "id": "gap-economics-market-and-company-financial-context",
            "category": "economics-normalization",
            "title": "Market and company financial context",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Normalize market records into model-ready numeric inputs with calibration artifacts.",
            "gapHash": "sha256-1479e55b6a27db3bc42d561c2fa8c2364d890ad3b1d1418e114b63e9a760c076"
          },
          {
            "id": "gap-economics-opex-and-operations-reserve-method",
            "category": "economics-normalization",
            "title": "Opex and operations reserve method",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Normalize opex records into model-ready numeric inputs with calibration artifacts.",
            "gapHash": "sha256-b9d83f5c025d242ec5eb0a16cce32fb6de52ff47baf8e6770663fa64dabfbe04"
          }
        ],
        "candidateSourceWorkOrders": []
      },
      "unresolvedCounts": {
        "sourceWorkOrders": 5,
        "candidateSourceWorkOrders": 0,
        "runtimeContracts": 0,
        "evidenceGaps": 5
      },
      "promotionSubstates": {
        "sourceCustody": null,
        "resourcePromotion": null,
        "customerUse": null
      },
      "proofBurden": [
        "Launch, delivery, capex, opex, and market records carry date, units, scope, and uncertainty.",
        "Price and ROI claims remain blocked until model-ready normalization is attached.",
        "Scenario rankings expose sensitivity to launch mass, development capex, and operations reserve.",
        "Attach reviewed payload or runtime-artifact intake reports before changing this closure state.",
        "Keep planner heuristics labeled as heuristics until promotion gates pass."
      ],
      "executableCommands": [
        "npm run science:source:intake -- <economics-payload.json>",
        "npm run science:economics:evidence",
        "npm run science:economics"
      ],
      "nextSprintActions": [
        "Capture a reviewed commercial-launch-pricing payload with raw and normalized hashes before this source can promote model outputs.",
        "OpenMDAO/Dymos or equivalent logistics optimization artifact with cost-sensitivity inputs.",
        "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts."
      ],
      "closurePlanHash": "sha256-dbdad43970e91dbeb9e1a15f9521568c48a72bdd6038f84fd96e71decf26c4d9"
    },
    {
      "releaseGateId": "materials-process-promotion",
      "title": "Materials/process promotion closure",
      "owner": "Manufacturing science",
      "priority": "P1",
      "closureState": "blocked-proof",
      "customerImpact": "Moves process pages from useful hypotheses toward defensible process, throughput, quality, and cost evidence.",
      "readyForCustomerClaim": false,
      "promotionBoundary": "This closure plan is governance and operations evidence only. It does not validate the underlying science or commercial claim.",
      "requiredProofPackages": {
        "sourcePayloadWorkOrders": [
          {
            "id": "source-ingest-nist-codata",
            "sourceId": "nist-codata",
            "title": "2022 CODATA Fundamental Physical Constants",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d"
          },
          {
            "id": "source-ingest-pds",
            "sourceId": "pds",
            "title": "Planetary Data System",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed mission-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11"
          },
          {
            "id": "source-ingest-nasa-spdf",
            "sourceId": "nasa-spdf",
            "title": "NASA Space Physics Data Facility",
            "domain": "space-environment",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed heliophysics-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-51d99b5f2da48846e8e4a77b621cb62ef65414de2e99c0a5eac3dd87bad87621"
          },
          {
            "id": "source-ingest-nasa-ccmc",
            "sourceId": "nasa-ccmc",
            "title": "Community Coordinated Modeling Center",
            "domain": "space-environment",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed space-weather-modeling-center payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-5c43fc31587c76573078911a506a40bae0680e9cedff867363f70cf7bc301d6e"
          },
          {
            "id": "source-ingest-noaa-swpc",
            "sourceId": "noaa-swpc",
            "title": "NOAA Space Weather Prediction Center Products and Data",
            "domain": "space-environment",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed space-weather-products payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-81ed94a99ffe23584f88770cc74cf7baf37c0aff4cf678a1f45a9a570c740bab"
          },
          {
            "id": "source-ingest-nist-chemistry-webbook",
            "sourceId": "nist-chemistry-webbook",
            "title": "NIST Chemistry WebBook SRD 69",
            "domain": "materials-and-process-modeling",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed chemistry-reference-database payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-c8ff016cbc8ee86304a0027a3a4bf3b954b1853a379196d071531f86800f2c3d"
          },
          {
            "id": "source-ingest-materials-project",
            "sourceId": "materials-project",
            "title": "Materials Project API",
            "domain": "materials-and-process-modeling",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed materials-property-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-cf340e050bde6a9a086fea668420d741780db2d71381b6b8de0222967e39b600"
          },
          {
            "id": "source-ingest-cantera",
            "sourceId": "cantera",
            "title": "Cantera",
            "domain": "materials-and-process-modeling",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed chemistry-transport-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-db1a361118b0599a32f646adbfd56174b3632166b2e0ecee2f1a8033a365161b"
          },
          {
            "id": "source-ingest-moose-framework",
            "sourceId": "moose-framework",
            "title": "MOOSE Framework",
            "domain": "materials-and-process-modeling",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed multiphysics-framework payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-f78f596ae140aade5b7d0fd53aa491e4a0478dca93cf5ea1c391bfe57ba93d7a"
          },
          {
            "id": "source-ingest-openfoam",
            "sourceId": "openfoam",
            "title": "OpenFOAM",
            "domain": "materials-and-process-modeling",
            "priority": "P1",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed cfd-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-566ae59e4e0f9d4741dfcaa81bce5623888a62582eb0729763f3dcc1953094e7"
          }
        ],
        "queryCustodyRecords": [
          {
            "queryId": "query-nist-codata-constants",
            "sourceId": "nist-codata",
            "provider": "NIST",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-0acb84eee7b7947a848daeedce840608fe9faa1dfaae8b1eb21ae1cbb1bc28be"
          },
          {
            "queryId": "query-pds-messenger-product-search",
            "sourceId": "pds",
            "provider": "NASA Planetary Data System",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-fbe8eab083a4bb3d2a1cfa7e1ad1989f439a374cd5ebb404483dbbec11d7ec1d"
          },
          {
            "queryId": "query-materials-project-property-record",
            "sourceId": "materials-project",
            "provider": "Materials Project",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-51d4f543e148cedae176705c8829ff3da1ab7f4b53a239ff6c78de2c82b447be"
          },
          {
            "queryId": "query-cantera-registry-custody",
            "sourceId": "cantera",
            "provider": "Cantera project",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-0544eed41f30b94f0a5881158adad8c7116ff56c228e3c93d14703ba12a29f48"
          },
          {
            "queryId": "query-moose-framework-registry-custody",
            "sourceId": "moose-framework",
            "provider": "Idaho National Laboratory",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-1906feb8d1d2a8bfbbf1295fc5aa640e99dfeae7f6d39f507334ad119f139cab"
          },
          {
            "queryId": "query-nist-chemistry-webbook-registry-custody",
            "sourceId": "nist-chemistry-webbook",
            "provider": "NIST",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-ec5f27052c18b383bfc63840b301307c1e8b109fa3086825842ff1c55630e0f2"
          },
          {
            "queryId": "query-openfoam-registry-custody",
            "sourceId": "openfoam",
            "provider": "OpenCFD / OpenFOAM community",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-be48cd7dbc1082da909e0093228c37d2f29421fd47236fa91525a4962c2be120"
          }
        ],
        "runtimeContracts": [
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "readinessState": "runtime-artifact-promoted",
            "nextAction": "Review promoted runtime artifact against claim-level acceptance criteria before using it in customer deliverables.",
            "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
            "readinessHash": "sha256-6c97cc882c1df4c7705d2dda567cd773d0dbf2397ade5edbb0514b9aaaebb1d5"
          }
        ],
        "requiredRuntimeArtifacts": [
          "Cantera chemistry/thermodynamics artifact for process reactions.",
          "MOOSE/OpenFOAM or equivalent thermal/process artifact for site-specific operation.",
          "Material property payload with temperature, composition, uncertainty, and citation metadata."
        ],
        "linkedEvidenceGaps": [
          {
            "id": "gap-materials-process-oxygen-isru",
            "category": "materials-process",
            "title": "Oxygen Extraction / ISRU process/material proof",
            "priorityLane": "P1-business-grade",
            "priorityScore": 75,
            "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
            "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
          },
          {
            "id": "gap-candidate-source-2026-em",
            "category": "candidate-source-custody",
            "title": "2026 EM candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
            "gapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531"
          },
          {
            "id": "gap-candidate-source-2026-jm2",
            "category": "candidate-source-custody",
            "title": "2026 JM2 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
            "gapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d"
          },
          {
            "id": "gap-candidate-source-2026-dn5",
            "category": "candidate-source-custody",
            "title": "2026 DN5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
            "gapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433"
          },
          {
            "id": "gap-materials-process-spf-db",
            "category": "materials-process",
            "title": "Superplastic Forming / Diffusion Bonding process/material proof",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
            "gapHash": "sha256-ae0748a11a838e23082f8103c11c90d9fe916318d6c4fc39df463393ee9e2e33"
          },
          {
            "id": "gap-materials-process-vacuum-sheet",
            "category": "materials-process",
            "title": "Vacuum Anisotropic Sheet Manufacturing process/material proof",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
            "gapHash": "sha256-8962058e82d93ebe648b6aa41c8720a622df2d1c66100a9837288e03a9aff4e0"
          },
          {
            "id": "gap-resource-taxonomy-spectra-record",
            "category": "resource-evidence",
            "title": "Taxonomy or spectra record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff"
          },
          {
            "id": "gap-resource-mission-or-archive-product",
            "category": "resource-evidence",
            "title": "Mission/archive product",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach Mission/archive product records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-8c7f9a7e86309ac82dcb0320ab62b11555bc49b14ab3f3fefa9b10e000261036"
          },
          {
            "id": "gap-trace-hybrid",
            "category": "scenario-trace-review",
            "title": "Hybrid Moon -> Asteroid -> Mercury trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-9b2025b5a713e047c204f589e827d16999d379dfd70d83f2afe5ce703be751cd"
          },
          {
            "id": "gap-trace-moon-first",
            "category": "scenario-trace-review",
            "title": "Moon-first Bootstrap trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a07797a7875d70590b15bfb0660c0d5391f295e6949d908cda489948b8388ce6"
          },
          {
            "id": "gap-candidate-source-2026-et3",
            "category": "candidate-source-custody",
            "title": "2026 ET3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-et3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-et3-source-intake-report.json.",
            "gapHash": "sha256-74f4bc84e7ea823c265ec80211167548ff6ed72bc97064d79d0d439737dba7f9"
          },
          {
            "id": "gap-candidate-source-2026-fs5",
            "category": "candidate-source-custody",
            "title": "2026 FS5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-fs5-source-intake-report.json.",
            "gapHash": "sha256-827bd3aee44db5fc618a31ce27ffe6ecd3fb358744fb0d70a7048d965fc0bc7c"
          },
          {
            "id": "gap-candidate-source-2026-hz4",
            "category": "candidate-source-custody",
            "title": "2026 HZ4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-hz4-source-intake-report.json.",
            "gapHash": "sha256-9d9dd560b7581f37ddf737dc9e7ac461bffbd398fe1b11473fe309590b73d227"
          },
          {
            "id": "gap-candidate-source-2026-jn4",
            "category": "candidate-source-custody",
            "title": "2026 JN4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jn4-source-intake-report.json.",
            "gapHash": "sha256-dc8d4a2f5c93e9e5ef37344887b384fddeaa72bf40230d4ad4fd43476a5899c8"
          },
          {
            "id": "gap-candidate-source-2026-jv3",
            "category": "candidate-source-custody",
            "title": "2026 JV3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jv3-source-intake-report.json.",
            "gapHash": "sha256-f8c55ed733b65b3672fb79d86c0847d1ccf231bd775aece43f126a3f48945771"
          },
          {
            "id": "gap-candidate-source-2026-ku1",
            "category": "candidate-source-custody",
            "title": "2026 KU1 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-ku1-source-intake-report.json.",
            "gapHash": "sha256-b38dd56c77c9f8a9c1c8b893a203ffd3193592a54c6590781414b56ccb73cf99"
          },
          {
            "id": "gap-candidate-source-2026-lx",
            "category": "candidate-source-custody",
            "title": "2026 LX candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-lx-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-lx-source-intake-report.json.",
            "gapHash": "sha256-00800b5fd8d8d2357ce6bb2e7406e8443edea5941cf0925c7fc8e3044c27aa74"
          },
          {
            "id": "gap-trace-asteroid-first",
            "category": "scenario-trace-review",
            "title": "Asteroid Feedstock-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-1507bb3a073d36e0376fcdee4f57ae7676eff4e7ece630c25f0ec35df9c8e31e"
          },
          {
            "id": "gap-trace-mars-first",
            "category": "scenario-trace-review",
            "title": "Mars-first Conventional Expansion trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a001e470feaccc1ac563477c2a78c86baa6c578879e643c6f63c914083e159a0"
          },
          {
            "id": "gap-trace-mercury-orbit",
            "category": "scenario-trace-review",
            "title": "Mercury Orbit-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a5fa55a583c4dbdad7357b606c59584859528aed662014720d5d7ff86c552ab9"
          },
          {
            "id": "gap-trace-mercury-polar",
            "category": "scenario-trace-review",
            "title": "Mercury Polar Surface-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-99163eaa428fa45c275a16aa56da8c959ddcde28d52917805ba9a1155aaa8262"
          }
        ],
        "candidateSourceWorkOrders": []
      },
      "unresolvedCounts": {
        "sourceWorkOrders": 10,
        "candidateSourceWorkOrders": 0,
        "runtimeContracts": 0,
        "evidenceGaps": 21
      },
      "promotionSubstates": {
        "sourceCustody": null,
        "resourcePromotion": null,
        "customerUse": null
      },
      "proofBurden": [
        "Process claims cite reviewed material property records and site/feedstock records.",
        "Throughput, quality, and cost claims remain blocked until runtime artifacts promote.",
        "Thermal and vacuum advantages are shown with penalties and uncertainty, not narrative-only claims.",
        "Attach reviewed payload or runtime-artifact intake reports before changing this closure state.",
        "Keep planner heuristics labeled as heuristics until promotion gates pass."
      ],
      "executableCommands": [
        "npm run science:source:intake -- <materials-process-payload.json>",
        "npm run science:materials",
        "npm run science:validation"
      ],
      "nextSprintActions": [
        "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
        "Cantera chemistry/thermodynamics artifact for process reactions.",
        "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU."
      ],
      "closurePlanHash": "sha256-410c338497ac236c233d703b329b085d0d425c7796bb0b54bf3c474b9a5e0e4d"
    },
    {
      "releaseGateId": "resource-candidate-promotion",
      "title": "Resource candidate promotion closure",
      "owner": "Resource ledger",
      "priority": "P1",
      "closureState": "blocked-proof",
      "customerImpact": "Allows asteroid/feedstock screens to become source-backed candidate reviews instead of synthetic workflow examples.",
      "readyForCustomerClaim": false,
      "promotionBoundary": "This closure plan is governance and operations evidence only. It does not validate the underlying science or commercial claim.",
      "requiredProofPackages": {
        "sourcePayloadWorkOrders": [
          {
            "id": "source-ingest-sbdb-api",
            "sourceId": "sbdb-api",
            "title": "JPL Small-Body Database API",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-03df633e2ee73cac09d65f2a2f5428e468e6ac89008e3f4378d6c8fd575ca8a5"
          },
          {
            "id": "source-ingest-cad-api",
            "sourceId": "cad-api",
            "title": "SBDB Close Approach Data API",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed close-approach-api payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71"
          },
          {
            "id": "source-ingest-pds",
            "sourceId": "pds",
            "title": "Planetary Data System",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed mission-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11"
          },
          {
            "id": "source-ingest-mpc",
            "sourceId": "mpc",
            "title": "Minor Planet Center Data",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed small-body-observation-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-6f4ec4d25fd364055d8c199c2c900fb140fcfd4c471ff4343dd8cb45ab928bc7"
          },
          {
            "id": "source-ingest-esa-psa",
            "sourceId": "esa-psa",
            "title": "ESA Planetary Science Archive",
            "domain": "small-body-and-resource-evidence",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed planetary-mission-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615"
          },
          {
            "id": "source-ingest-jaxa-darts",
            "sourceId": "jaxa-darts",
            "title": "DARTS Space Science Data Archive",
            "domain": "ephemeris-and-astronomy",
            "priority": "P0",
            "ingestionState": "contract-ready-no-reviewed-payload",
            "promotionAllowed": false,
            "nextAction": "Capture a reviewed space-science-archive payload with raw and normalized hashes before this source can promote model outputs.",
            "blockers": [
              "No raw source payload hash has been attached to this ingestion work order.",
              "No normalized parser output has been reviewed for promotion.",
              "No reviewer approval has promoted this source into a model-ready record."
            ],
            "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2"
          }
        ],
        "queryCustodyRecords": [
          {
            "queryId": "query-sbdb-asteroid-record-screen",
            "sourceId": "sbdb-api",
            "provider": "NASA/JPL Small-Body Database",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-06222352a14f2aa3df3d8007b9c4538c7d38c0d5740f734b9b7e091f9ff0d5ab"
          },
          {
            "queryId": "query-cad-2026-close-approach-screen",
            "sourceId": "cad-api",
            "provider": "NASA/JPL CNEOS CAD",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-e1dd6bf53bf1f8deedd1eca765ca58f8d04ae1cc2dcbd2fc7cc60efe3af8258d"
          },
          {
            "queryId": "query-mpc-observation-bridge",
            "sourceId": "mpc",
            "provider": "IAU Minor Planet Center",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-387e10e01e3f5b19f29546804413e2a450f266c3c66b543967dd81ed58a9092f"
          },
          {
            "queryId": "query-pds-messenger-product-search",
            "sourceId": "pds",
            "provider": "NASA Planetary Data System",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-fbe8eab083a4bb3d2a1cfa7e1ad1989f439a374cd5ebb404483dbbec11d7ec1d"
          },
          {
            "queryId": "query-esa-psa-registry-custody",
            "sourceId": "esa-psa",
            "provider": "European Space Agency",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-bd033f065f2c56715159b5b02f5b60a48127345c50d258a2ee4a0426485b945d"
          },
          {
            "queryId": "query-jaxa-darts-registry-custody",
            "sourceId": "jaxa-darts",
            "provider": "ISAS/JAXA",
            "reviewCandidate": false,
            "promotionAllowed": false,
            "queryHash": "sha256-2e1b18587988d3ce23fa54593b4b2d8d811eeb8c967fc55935ee40fa07e2be72"
          }
        ],
        "runtimeContracts": [
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "readinessState": "blocked-runtime-prerequisites",
            "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
            "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
            "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff"
          }
        ],
        "requiredRuntimeArtifacts": [
          "Orbit or close-approach propagation artifact when candidate ranking depends on geometry."
        ],
        "linkedEvidenceGaps": [
          {
            "id": "gap-materials-process-oxygen-isru",
            "category": "materials-process",
            "title": "Oxygen Extraction / ISRU process/material proof",
            "priorityLane": "P1-business-grade",
            "priorityScore": 75,
            "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
            "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
          },
          {
            "id": "gap-candidate-source-2026-em",
            "category": "candidate-source-custody",
            "title": "2026 EM candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
            "gapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531"
          },
          {
            "id": "gap-candidate-source-2026-jm2",
            "category": "candidate-source-custody",
            "title": "2026 JM2 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 74,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
            "gapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d"
          },
          {
            "id": "gap-candidate-source-2026-dn5",
            "category": "candidate-source-custody",
            "title": "2026 DN5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
            "gapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433"
          },
          {
            "id": "gap-materials-process-vacuum-sheet",
            "category": "materials-process",
            "title": "Vacuum Anisotropic Sheet Manufacturing process/material proof",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
            "gapHash": "sha256-8962058e82d93ebe648b6aa41c8720a622df2d1c66100a9837288e03a9aff4e0"
          },
          {
            "id": "gap-resource-taxonomy-spectra-record",
            "category": "resource-evidence",
            "title": "Taxonomy or spectra record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 73,
            "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff"
          },
          {
            "id": "gap-resource-cad-close-approach-record",
            "category": "resource-evidence",
            "title": "CAD close-approach record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach CAD close-approach record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-8fc55bc0f1f95de19673711ea406c890ceec3b66c4defee971ec3228592c2c74"
          },
          {
            "id": "gap-resource-mission-or-archive-product",
            "category": "resource-evidence",
            "title": "Mission/archive product",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach Mission/archive product records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-8c7f9a7e86309ac82dcb0320ab62b11555bc49b14ab3f3fefa9b10e000261036"
          },
          {
            "id": "gap-resource-mpc-observation-bridge",
            "category": "resource-evidence",
            "title": "MPC observation bridge",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach MPC observation bridge records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-1f578fbb47b5ebc0f44778b06ed6b6c850ea36eec18607c6077aedc809b65309"
          },
          {
            "id": "gap-resource-sbdb-orbit-record",
            "category": "resource-evidence",
            "title": "SBDB orbit and physical-property record",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Attach SBDB orbit and physical-property record records for candidate objects with hashes and source citations.",
            "gapHash": "sha256-cf5576baa620019c4c2d21bb4bcc8b4de7cecb89d16b7fb723565209fa14f084"
          },
          {
            "id": "gap-trace-hybrid",
            "category": "scenario-trace-review",
            "title": "Hybrid Moon -> Asteroid -> Mercury trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-9b2025b5a713e047c204f589e827d16999d379dfd70d83f2afe5ce703be751cd"
          },
          {
            "id": "gap-trace-moon-first",
            "category": "scenario-trace-review",
            "title": "Moon-first Bootstrap trace blockers",
            "priorityLane": "P1-business-grade",
            "priorityScore": 69,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a07797a7875d70590b15bfb0660c0d5391f295e6949d908cda489948b8388ce6"
          },
          {
            "id": "gap-candidate-source-2026-et3",
            "category": "candidate-source-custody",
            "title": "2026 ET3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-et3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-et3-source-intake-report.json.",
            "gapHash": "sha256-74f4bc84e7ea823c265ec80211167548ff6ed72bc97064d79d0d439737dba7f9"
          },
          {
            "id": "gap-candidate-source-2026-fs5",
            "category": "candidate-source-custody",
            "title": "2026 FS5 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-fs5-source-intake-report.json.",
            "gapHash": "sha256-827bd3aee44db5fc618a31ce27ffe6ecd3fb358744fb0d70a7048d965fc0bc7c"
          },
          {
            "id": "gap-candidate-source-2026-hz4",
            "category": "candidate-source-custody",
            "title": "2026 HZ4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-hz4-source-intake-report.json.",
            "gapHash": "sha256-9d9dd560b7581f37ddf737dc9e7ac461bffbd398fe1b11473fe309590b73d227"
          },
          {
            "id": "gap-candidate-source-2026-jn4",
            "category": "candidate-source-custody",
            "title": "2026 JN4 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jn4-source-intake-report.json.",
            "gapHash": "sha256-dc8d4a2f5c93e9e5ef37344887b384fddeaa72bf40230d4ad4fd43476a5899c8"
          },
          {
            "id": "gap-candidate-source-2026-jv3",
            "category": "candidate-source-custody",
            "title": "2026 JV3 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jv3-source-intake-report.json.",
            "gapHash": "sha256-f8c55ed733b65b3672fb79d86c0847d1ccf231bd775aece43f126a3f48945771"
          },
          {
            "id": "gap-candidate-source-2026-ku1",
            "category": "candidate-source-custody",
            "title": "2026 KU1 candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-ku1-source-intake-report.json.",
            "gapHash": "sha256-b38dd56c77c9f8a9c1c8b893a203ffd3193592a54c6590781414b56ccb73cf99"
          },
          {
            "id": "gap-candidate-source-2026-lx",
            "category": "candidate-source-custody",
            "title": "2026 LX candidate source custody intake",
            "priorityLane": "P1-business-grade",
            "priorityScore": 68,
            "nextAction": "Create and review evidence/source-candidate-payloads/2026-lx-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-lx-source-intake-report.json.",
            "gapHash": "sha256-00800b5fd8d8d2357ce6bb2e7406e8443edea5941cf0925c7fc8e3044c27aa74"
          },
          {
            "id": "gap-trace-asteroid-first",
            "category": "scenario-trace-review",
            "title": "Asteroid Feedstock-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-1507bb3a073d36e0376fcdee4f57ae7676eff4e7ece630c25f0ec35df9c8e31e"
          },
          {
            "id": "gap-trace-mars-first",
            "category": "scenario-trace-review",
            "title": "Mars-first Conventional Expansion trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a001e470feaccc1ac563477c2a78c86baa6c578879e643c6f63c914083e159a0"
          },
          {
            "id": "gap-trace-mercury-orbit",
            "category": "scenario-trace-review",
            "title": "Mercury Orbit-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-a5fa55a583c4dbdad7357b606c59584859528aed662014720d5d7ff86c552ab9"
          },
          {
            "id": "gap-trace-mercury-polar",
            "category": "scenario-trace-review",
            "title": "Mercury Polar Surface-first trace blockers",
            "priorityLane": "P2-hardening",
            "priorityScore": 65,
            "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
            "gapHash": "sha256-99163eaa428fa45c275a16aa56da8c959ddcde28d52917805ba9a1155aaa8262"
          }
        ],
        "candidateSourceWorkOrders": [
          {
            "workOrderId": "small-body-source-work-order-2026-jm2",
            "sourceCandidateId": "cad-2026 JM2",
            "designation": "2026 JM2",
            "queueRank": 1,
            "reviewPriorityScore": 52.39,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-b52331ce9a5cd6c17d6aafaa4119aee5533301a87cded5d6a06e684cf07fa134"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-em",
            "sourceCandidateId": "cad-2026 EM",
            "designation": "2026 EM",
            "queueRank": 2,
            "reviewPriorityScore": 44.28,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-5bdb8eb61a495b8a9b53e1cfc73fb5ccdbb5ad0910d3db8a4584ed501c2616f9"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-dn5",
            "sourceCandidateId": "cad-2026 DN5",
            "designation": "2026 DN5",
            "queueRank": 3,
            "reviewPriorityScore": 39.5,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-620143df6681d87f5385af49ebf5ccc6bd18b20679f3e5e292185d1b5f0327d0"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-lx",
            "sourceCandidateId": "cad-2026 LX",
            "designation": "2026 LX",
            "queueRank": 4,
            "reviewPriorityScore": 39.44,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-8c14435b45122ce12954b3cdff703649a3c597e4399f447c3d66d06c0615617e"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-ku1",
            "sourceCandidateId": "cad-2026 KU1",
            "designation": "2026 KU1",
            "queueRank": 5,
            "reviewPriorityScore": 36.59,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-9f67dd23c5090587d15155d69e13638d980daaa9b46e66af99b0a82c007689d3"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-fs5",
            "sourceCandidateId": "cad-2026 FS5",
            "designation": "2026 FS5",
            "queueRank": 6,
            "reviewPriorityScore": 30.19,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-09109b23d6398297094ed3d3b256f48c4a47f25c782a345c919d9de7ab6154c9"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-et3",
            "sourceCandidateId": "cad-2026 ET3",
            "designation": "2026 ET3",
            "queueRank": 7,
            "reviewPriorityScore": 25.97,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-5307e6095ba506ff9e307252b1b93187560a31d7d43a125df1226e73c39a22d7"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-jn4",
            "sourceCandidateId": "cad-2026 JN4",
            "designation": "2026 JN4",
            "queueRank": 8,
            "reviewPriorityScore": 24.65,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-db8b7e318dfb4712806ffcd94b5e853eb00e04027da223999f907e3dfd42a8b4"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-jv3",
            "sourceCandidateId": "cad-2026 JV3",
            "designation": "2026 JV3",
            "queueRank": 9,
            "reviewPriorityScore": 24.51,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-ae4f5464fe7a729075d1796422f376bef5116a139fa7afe89e1f39f2d18c489f"
          },
          {
            "workOrderId": "small-body-source-work-order-2026-hz4",
            "sourceCandidateId": "cad-2026 HZ4",
            "designation": "2026 HZ4",
            "queueRank": 10,
            "reviewPriorityScore": 24.43,
            "reason": "No candidate-specific reviewed source custody intake has passed.",
            "payloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence.",
            "workOrderHash": "sha256-ca56492f342a3ffd2c86d75c51ea4e032263dc65138f58c461ebb42a700b4b92"
          }
        ]
      },
      "unresolvedCounts": {
        "sourceWorkOrders": 6,
        "candidateSourceWorkOrders": 10,
        "runtimeContracts": 1,
        "evidenceGaps": 23
      },
      "promotionSubstates": {
        "sourceCustody": "blocked",
        "resourcePromotion": "blocked",
        "customerUse": "blocked"
      },
      "proofBurden": [
        "Each promoted candidate has object-specific SBDB and CAD records.",
        "Each promoted candidate has a reviewed candidate-source work-order intake report.",
        "Composition/resource claims cite taxonomy, spectra, or mission/archive products.",
        "Close-approach frequency and v-infinity remain logistics signals, not composition evidence.",
        "Customer-facing use remains blocked until source-use clearance passes for the candidate evidence packet.",
        "Attach reviewed payload or runtime-artifact intake reports before changing this closure state.",
        "Keep planner heuristics labeled as heuristics until promotion gates pass."
      ],
      "executableCommands": [
        "npm run science:smallbody:workorder-intake -- <candidate-source-payload.json>",
        "npm run science:smallbody:source-promotion",
        "npm run science:source:intake -- <sbdb-cad-taxonomy-payload.json>",
        "npm run science:source:promotion",
        "npm run science:asteroids"
      ],
      "nextSprintActions": [
        "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
        "Create evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json and validate evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
        "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
        "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU."
      ],
      "closurePlanHash": "sha256-053cb17ecdd9afcd3bfd272754de376014200ab0370e5dae978f31be1bf8b864"
    }
  ],
  "ledgerHash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c"
}
;
